var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVelocidadRestablecida(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#589e3e;}.cls-3,.cls-4,.cls-5{fill:#55953d;}.cls-3{opacity:0.2;}.cls-4{opacity:0.5;}.cls-5{opacity:0.8;}.cls-6{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-velocidad-restablecida") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.73,120.18a66.45,66.45,0,0,1-6.91,27.42L167,143.72a57.61,57.61,0,0,0,6-23.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.51,120.54a66.45,66.45,0,0,0,6.9,27.06l7.83-3.88a57.64,57.64,0,0,1-6-23.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.74,91a57.89,57.89,0,0,0-6.47,23.93H47.52a66.76,66.76,0,0,1,7.63-28.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.06,68.67A58.91,58.91,0,0,0,65.31,86.52l-7.4-4.64A67.61,67.61,0,0,1,78.6,61.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.68,59.47A58.11,58.11,0,0,0,87.63,66l-4.55-7.47a66.63,66.63,0,0,1,29-7.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.61,66A57.82,57.82,0,0,0,117,59.45l.17-8.74a66.76,66.76,0,0,1,28.65,7.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M163.65,86.1a58.72,58.72,0,0,0-17.87-17.67L150.36,61a67.68,67.68,0,0,1,21,20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173,114.9a57.93,57.93,0,0,0-6.62-24.22L174,86.41a66.67,66.67,0,0,1,7.75,28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M73.86,127.06l27.24-21.22a13.45,13.45,0,1,1,7.2,18.71Zm39.21-22.47a7.21,7.21,0,0,0-2.66.5A7.32,7.32,0,0,0,106.3,109l-.31.7-12.65,9.86,16-1.17.7.32a7.38,7.38,0,0,0,9.78-3.74,7.39,7.39,0,0,0-6.74-10.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.46,160.53H90.78a5.31,5.31,0,0,1-5.3-5.31V148a5.31,5.31,0,0,1,5.3-5.3h47.68a5.31,5.31,0,0,1,5.31,5.3v7.19A5.31,5.31,0,0,1,138.46,160.53Zm-46.92-6.06h46.17v-5.68H91.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVelocidadRestablecida);
export default __webpack_public_path__ + "static/media/ic-velocidad-restablecida.efd47e5433ea676e73a7f98d9d659bf1.svg";
export { ForwardRef as ReactComponent };